/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-23 12:23:14
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-24 12:46:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorText/slice/index.ts
 */

import { isCurrentPrimary } from '@/src/constrains/SalesChannelMultiLanguageSelect';
import {
  getSalesChannelContentText,
  postSalesChannelContentText,
} from '@/src/request/salesChannel/content';
import { msg } from '@/src/tools/message';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { getCurrentSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/tools';
import {
  generateDefaultState as _generateDefaultState,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
  hasError,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
} from 'src/pages/SalesChannelContentEditor/slice/selectors'; //
import {
  TextTheme,
  convertDataFromServerToRedux,
  fixedCollapse,
  getThemesBySize,
} from '../tool';

export const fetchText = createAsyncThunk(
  'fetchSalesChannelContentText',
  async (data: any) => {
    const { uuid, params } = data;
    const isPrimary = isCurrentPrimary();
    const size = getCurrentSize();
    const response = await getSalesChannelContentText(uuid, params);
    return {
      response,
      isPrimary,
      size,
    };
  },
);

export const submitText = createAsyncThunk(
  'submitSalesChannelCotentText',
  async ({ body, params }: any) => {
    const response = await postSalesChannelContentText(body, params);
    return {
      response,
    };
  },
);

export const getLoaded = () => {
  return _getLoaded(EnumReducers.text);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.text);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.text, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.text, id);
};

export const getGeneralFeaturedProduct = () => {
  return _getGeneralFeaturedProduct(EnumReducers.text);
};

export const getState = () => {
  return _getState(EnumReducers.text);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.text);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.text);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.text);
};

export const getThemes = () => {
  return createSelector(
    (state: any) => state.salesChannelContent[EnumReducers.text].theme,
    (v) => v,
  );
};

export const getTheme = (type: TextTheme) => {
  return createSelector(
    (state: any) => state.salesChannelContent[EnumReducers.text].theme,
    (v) => v[type],
  );
};

const _defaultState = _generateDefaultState(fixedCollapse);

const defaultState = {
  ...defaultStatus,
  ..._defaultState,
  theme: getThemesBySize(EPreviewSize.WIDE),
};

const salesChannelCotentTextPage = createSlice({
  name: 'salesChannelContentTextPage',
  initialState: defaultState,
  reducers: {
    resetData(state) {
      assData(state, defaultState);
    },
    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },
    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    onChangeField(state, action) {
      const { type, prop, value } = action.payload;
      if (Array.isArray(prop)) {
        prop.map((p) => {
          state.theme[type][p] = value[p];
        });
      } else {
        state.theme[type][prop] = value;
      }

      state.hasModified = true;
    },
    onReset(state, action) {
      const { type, size } = action.payload;
      state.theme[type] = getThemesBySize(size)[type];
      state.hasModified = true;
    },
    validation(state) {
      hasError(state, state.collapseErrorMsgDisplay || {});
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchText.fulfilled, (state, action) => {
      const { response, size } = action.payload;
      const _data = convertDataFromServerToRedux(response, size) || {};
      assData(state, _data);
    });
    builder.addCase(submitText.fulfilled, (state) => {
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      console.log('luke1');
      state.hasModified = false;
    });
  },
});

export const {
  resetData,
  onErrorChange,
  onCollapseOpen,
  validation,
  onChangeField,
  onReset,
} = salesChannelCotentTextPage.actions;

export default salesChannelCotentTextPage.reducer;
